"use strict";
/*
 * Created on 26. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Tomas Leity
 */

var SalesDashboardComparatorItemParams =
/**
 * @param year
 * @param week
 * @param formatId
 * @param promotionWeekType
 * @param promotionIds
 * @param collectionSuffix
 */
function SalesDashboardComparatorItemParams(year, week, formatId, promotionWeekType, promotionIds, collectionSuffix) {
  _classCallCheck(this, SalesDashboardComparatorItemParams);

  this.year = year;
  this.week = week;
  this.formatId = formatId;
  this.promotionWeekType = promotionWeekType;
  this.promotionIds = promotionIds;
  this.collectionSuffix = collectionSuffix;
};

exports.SalesDashboardComparatorItemParams = SalesDashboardComparatorItemParams;